// Google Analytics utility functions

// Track page views
export const trackPageView = (url) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', process.env.REACT_APP_GA_TRACKING_ID, {
      page_path: url,
    });
  }
};

// Track custom events
export const trackEvent = (action, category, label, value) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};

// Track user engagement events
export const trackUserEngagement = (eventName, parameters = {}) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, parameters);
  }
};

// Common tracking events for your app
export const trackFilingCreated = (filingType) => {
  trackEvent('filing_created', 'engagement', filingType);
};

export const trackUserSignUp = (method) => {
  trackEvent('sign_up', 'engagement', method);
};

export const trackUserLogin = (method) => {
  trackEvent('login', 'engagement', method);
};

export const trackPaymentCompleted = (amount, currency = 'USD') => {
  trackEvent('purchase', 'ecommerce', 'filing_payment', amount);
  trackUserEngagement('purchase', {
    transaction_id: Date.now().toString(),
    value: amount,
    currency: currency,
  });
};
